<template>
	<div class="GoodDetail">
		<common-body aside="1">
			<div slot="commonMain" class="detail_box" v-loading.lock="loadingStatus">
				<div v-if="detail">
					<el-row type="flex" align="middle" class="location_box">
						<div class="location_icon">
							<i class="el-icon-s-promotion"></i>
						</div>
						<el-row type="flex" align="middle" class="location_text">
							<div>当前位置：</div>
							<el-button @click="goBack" type="text">产品列表</el-button>
							<div class="location_xie">/</div>
							<div>产品详情</div>
						</el-row>
					</el-row>
					<div class="good_box">
						<el-row type="flex" align="middle">
							<el-carousel class="good_img">
							      <el-carousel-item v-for="(img,index) in detail.images" :key="index">
							        <img :src="img" />
							      </el-carousel-item>
							    </el-carousel>
							<div class="good_r">
								<div class="good_name text_more">{{detail.name}}</div>
								<div class="good_text">产品型号：{{detail.model}}</div>
								<div class="good_text">规格：{{detail.specs_text}}</div>
								<div class="good_text">单位：{{detail.unit}}</div>
								<el-row type="flex" align="middle" justify="space-between">
									<div class="good_price">¥ {{detail.price}}</div>
									<!-- <div v-if="userInfo.is_update==1" @click="editPrice" class="good_edit">编辑价格</div> -->
								</el-row>
							</div>
						</el-row>
						<el-row type="flex" class="good_b">
							<el-row type="flex" class="good_l">
								<div class="good_title">产品详情</div>
								<div class="good_icon">
									<i class="el-icon-caret-right"></i>
								</div>
							</el-row>
							<div class="good_detail" v-html="detail.content">
								
							</div>
						</el-row>
					</div>
				</div>
				<el-dialog v-if="detail" class="price_dialog" top="5vh" :visible.sync="editStatus" :append-to-body="true">
					<div class="detail_title" slot="title">{{formTitle}}</div>
					<el-form :hide-required-asterisk="hideRequired" :rules="rules" ref='priceForm' label-position="right" :model="priceForm" class="detail_box">
						<el-form-item label="产品价格" prop="price">
							<el-row type="flex" align="middle" class="price_t">
								<el-input type="number" placeholder="请输入" v-model="priceForm.price"></el-input>
								<div class="price_unit">元</div>
							</el-row>							
						</el-form-item>
						<el-form-item label="长度价格" v-if="detail.specs_value!=''">
							<el-row class="price_box" type="flex" align="middle" v-for="(item,index) in specs_value" :key='index'>
								<div class="price_l">{{item.title}}mm</div>
								<el-row type="flex" align="middle" class="price_r">
									<el-input type="number" class="price_input" placeholder="请输入" v-model="item.price"></el-input>
									<div class="price_unit">元</div>
								</el-row>
							</el-row>
						</el-form-item>
						<el-form-item>
							<div class="detail_btn" @click="submitForm('priceForm')">确认</div>
						</el-form-item>
					</el-form>
				</el-dialog>
			</div>
		</common-body>
	</div>
</template>

<script>
	export default {
		name: 'GoodDetail',
		data() {
			return {
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				priceStatus: !1,
				editStatus: !1,
				loadingStatus: !0,
				goods_id: 1,
				detail: null,
				formTitle: '价格编辑',
				clearable: !0,
				hideRequired: !0,
				priceForm: {
					goods_id: '',
					price: '',
					specs_value: ''
				},
				rules: {
					price: [{
						required: true,
						message: '价格不能为空'
					}]
				},
				specs_value: []
			}
		},
		beforeRouteLeave(to,from,next) {
			if(to.name === 'GoodList'){
				to.meta.keepAlive = !0
			}
			next()
		},
		created() {
			this.reload();
		},
		methods: {
			reload() {
				let that = this
				that.goods_id = that.$route.query.id,that.getDetail()
			},
			getDetail(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getGoodsDetails',{goods_id: that.goods_id}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data,specs = null,specs_list=[]
						if(detail.valuation==3){
							specs = JSON.parse(detail.specs_price)
						}else{
							specs = JSON.parse(detail.specs_value)
						}
						specs.forEach((item,index)=>{
							specs_list.push(item.title)
						})
						detail.specs_text = specs_list.join("、")
						that.detail = detail,that.loadingStatus = !1 
						that.priceForm.goods_id = res.data.id,that.priceForm.price = res.data.price,that.priceForm.specs_value = res.data.specs_value
						if(res.data.specs_value!="") that.specs_value = JSON.parse(res.data.specs_value)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			editPrice(e){
				let that = this
				that.editStatus = !0
			},
			submitForm(priceForm) {
				let that = this
				if (that.priceStatus) return
				that.$refs[priceForm].validate((valid) => {
					if (valid) {
						that.priceStatus = !0
						that.priceForm.specs_value = JSON.stringify(that.specs_value)
						that.$post('addons/hlm/api.Goods/addPrice', that.priceForm).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.editStatus = !1, that.$message({
									message: '编辑成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.priceStatus = !1
									}
								}), that.getDetail()
							} else {
								that.priceStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.priceStatus = !1
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			goBack(){
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/goodDetail.css'>
	/* px2rem能正常转换 */
</style>
